import { Contract } from '..'

export const getContracts = (): Contract[] => {
    return [
        {
            contractId: 1,
            contractNumber: '82275886-3416',
        },
        {
            contractId: 2,
            contractNumber: '39213687-2245',
        },
        {
            contractId: 3,
            contractNumber: '88670457-5406',
        },
        {
            contractId: 4,
            contractNumber: '84949844-6941',
        },
        {
            contractId: 5,
            contractNumber: '71655060-2619',
        },
        {
            contractId: 6,
            contractNumber: '38309281-6337',
        },
    ]
}
